module.exports = __webpack_public_path__ + "media/images/front/carton-1514f85be689f53b38804fd0825982dd.jpg";